export default class HeaderStylesEnum {
    static get CLASSIC() {
        return 'classic';
    }

    static get MINIMAL() {
        return 'minimal';
    }

    static get options() {
        return {
            MINIMAL: this.MINIMAL,
            CLASSIC: this.CLASSIC
        };
    }
}
